import { Typography, message } from 'antd';
import React from 'react';
import Sheet from 'react-modal-sheet';
import { InsurerQuote, formatInr, mockInsurerQuotes } from './mockData';
import styles from './styles.module.css';

type Props = {
  open: boolean;
  vehicleLabel?: string;
  onClose: () => void;
};

const InsuranceCompareSheet: React.FC<Props> = ({
  open,
  vehicleLabel,
  onClose,
}) => {
  const select = (q: InsurerQuote) => {
    message.success(`Redirecting to ${q.insurer}…`);
    onClose();
  };

  const cheapest = Math.min(...mockInsurerQuotes.map((q) => q.premium));

  return (
    <Sheet
      isOpen={open}
      onClose={onClose}
      detent='content-height'
      disableScrollLocking
      style={{ zIndex: 100, maxWidth: 520, margin: 'auto' }}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
          <div className={styles.compareSheet}>
            <div>
              <div className={styles.addTitle}>Compare insurance</div>
              <div className={styles.addSub}>
                {vehicleLabel ? `For ${vehicleLabel} · ` : ''}Quotes from
                IRDAI-licensed insurers via our partner network.
              </div>
            </div>

            {mockInsurerQuotes
              .sort((a, b) => a.premium - b.premium)
              .map((q) => (
                <div
                  key={q.insurer}
                  className={styles.quoteCard}
                  onClick={() => select(q)}
                >
                  <div className={styles.quoteHead}>
                    <div className={styles.quoteInsurer}>
                      <span
                        className={styles.quoteLogo}
                        style={{ background: q.logoBg }}
                      >
                        {q.insurer[0]}
                      </span>
                      {q.insurer}
                      {q.premium === cheapest && (
                        <span
                          style={{
                            background: '#dcfce7',
                            color: '#0a8a3f',
                            fontSize: 9,
                            fontWeight: 700,
                            padding: '2px 7px',
                            borderRadius: 999,
                            marginLeft: 4,
                            letterSpacing: 0.4,
                          }}
                        >
                          BEST PRICE
                        </span>
                      )}
                    </div>
                    <div className={styles.quotePremium}>
                      {formatInr(q.premium)}
                      <span
                        style={{ fontSize: 10, fontWeight: 500, color: '#6b7280' }}
                      >
                        /year
                      </span>
                    </div>
                  </div>
                  <div className={styles.quoteMeta}>
                    <span>IDV {formatInr(q.idv)}</span>
                    <span>•</span>
                    <span>{q.cashlessGarages.toLocaleString('en-IN')} cashless garages</span>
                    <span>•</span>
                    <span>{q.claimRatio}% claim ratio</span>
                  </div>
                  <div className={styles.quoteChips}>
                    {q.addons.map((a) => (
                      <span key={a} className={styles.quoteChip}>
                        {a}
                      </span>
                    ))}
                  </div>
                </div>
              ))}

            <Typography.Text
              style={{ fontSize: 10, color: '#9ca3af', textAlign: 'center' }}
            >
              Quotes powered by our IRDAI-registered insurance partner.
              Coverage subject to insurer underwriting.
            </Typography.Text>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={onClose} />
    </Sheet>
  );
};

export default InsuranceCompareSheet;
